import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AngularFirestore } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import { ScreenListing } from '../../../shared';

@Component({
  selector: 'signgaze-screen-listing-item',
  templateUrl: './screen-listing-item.component.html',
  styleUrls: ['./screen-listing-item.component.scss'],
})
export class ScreenListingItemComponent implements OnChanges {
  readonly subSink: SubSink = new SubSink();
  @Input() isTrendingActive;
  @Input()
  screenId = '';

  screenDetail$: Observable<ScreenListing>;

  constructor(private afs: AngularFirestore) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['screenId']) {
      if (this.screenId) {
        this.getScreenDetails();
      }
    }
  }

  public getScreenDetails(): void {
    this.screenDetail$ = this.afs
      .doc<ScreenListing>(`screens/${this.screenId}`)
      .valueChanges();
  }
}
